/* eslint-disable no-useless-catch */
import {
  calculateFormula,
  calculateMaterials,
  getById,
  getByIdProductTaxonomy,
  hasCalculatorProducts,
} from 'redux/services/materialsCalculatorServices'
import { SET_PRODUCTS_MATERIALS } from 'redux/types'

export const saveProductsMaterials = product => ({
  type: SET_PRODUCTS_MATERIALS,
  payload: product,
})

export const getByIdCalculator =
  ({ id, requestId }) =>
  async () => {
    try {
      const response = await getById({ id, requestId })
      const { data, status } = response
      if (status === 200 && data?.Data) {
        return data.Data
      }
    } catch (err) {
      throw err
    }
  }
export const calculateDoFormula =
  ({ CalculatorFormulaId, payload }) =>
  async () => {
    try {
      const response = await calculateFormula({
        CalculatorFormulaId,
        payload,
      })
      const { data, status } = response
      if (status === 200 && data?.Data) {
        return data.Data
      }
    } catch (err) {
      throw err
    }
  }
export const getByIdProductTaxonomyCalculator =
  ({
    departmentId,
    categoryId,
    subCategoryId,
    productId,
    companyId,
    requestId,
  }) =>
  async () => {
    try {
      const response = await getByIdProductTaxonomy({
        departmentId,
        categoryId,
        subCategoryId,
        productId,
        companyId,
        requestId,
      })
      const { data, status } = response
      if (status === 200 && data?.Data) {
        return data.Data
      }
    } catch (err) {
      throw err
    }
  }
export const calculateDoCalculator =
  ({ payload, requestId }) =>
  async () => {
    try {
      const response = await calculateMaterials({ payload, requestId })
      const { data, status } = response
      if (status === 200 && data?.Data) {
        return data.Data
      } else {
        return data
      }
    } catch (err) {
      if (err.response) {
        return err.response.data
      } else {
        throw err
      }
    }
  }
export const validateHasCalculator =
  ({ payload }) =>
  async () => {
    try {
      const response = await hasCalculatorProducts({ payload })
      const { data, status } = response
      if (status === 200 && data?.Data) {
        return data.Data
      } else {
        return data
      }
    } catch (err) {
      if (err.response) {
        return err.response.data
      } else {
        throw err
      }
    }
  }
